import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=588d452b&scoped=true"
import script from "./newsdetails.vue?vue&type=script&lang=js"
export * from "./newsdetails.vue?vue&type=script&lang=js"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=588d452b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d452b",
  null
  
)

export default component.exports